import { Component, OnInit,Input,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/';
import { AlertService, AreaOfStudyService, AppService } from '../_services/index';
import $ from 'jquery/dist/jquery';
import {NgbModal, NgbActiveModal,NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

class AreaOfStudy {
  id: number;
  name: string;
  description: string;
  is_active: string;
}

@Component({
  selector: 'app-area-of-study',
  templateUrl: './area-of-study.component.html',
  styles: []
})
export class AreaOfStudyComponent implements OnInit {

  dtOptions: DataTables.Settings = {}; //  DataTable
  dtTrigger = new Subject(); //  DataTable
  areaofstudyList: AreaOfStudy[] = []; // Table Data list
  isSubmitted = false;
  // countryAddForm: FormGroup;
  getAreaOfStudy = {
    id:'',
    name: '',
    description: '',
    is_active: 'N'
  };

  modalReference:NgbActiveModal;
  modalTitle:string;

  constructor(
              public router: Router,
              private dataService:AreaOfStudyService,
              private alertService: AlertService,
              private AppService: AppService,
              private modalService: NgbModal
             ) { }
  areaofstudy = {
    id:'',
    name: '',      
    description: '',
    is_active: 'Y'
  };
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.allAreaOfStudy();
  }

  allAreaOfStudy(){
    this.loadShow();
    this.dataService.getAllAreaOfStudy()
        .pipe().subscribe(data => { 
          this.areaofstudyList = data['area_of_study']; 
          this.dtTrigger.next(); // Data Table
          this.loadHide();
        });
      }

  open(content) {   
    this.isSubmitted = false;
    this.areaofstudy.id='';
    this.areaofstudy.name = '',
    this.areaofstudy.description = '',
    this.areaofstudy.is_active = 'Y';
    this.modalTitle = "Add Area Of Study";
    this.modalReference = this.modalService.open(content);
  }

  edit(id,content){
    this.loadShow();
    this.dataService.editAreaOfStudy(id)
        .pipe().subscribe(data => { 
                this.getAreaOfStudy = data['area_of_study']; 
                this.areaofstudy = {
                      id:this.getAreaOfStudy.id,
                      name:this.getAreaOfStudy.name,                        
                      description:this.getAreaOfStudy.description,
                      is_active:this.getAreaOfStudy.is_active
                };
                this.loadHide();
                this.modalTitle = "Edit Area Of Study";
                this.modalReference = this.modalService.open(content);
            });
         }



  save(val,f){
    this.isSubmitted = true;
    if(f.form.valid) {
      this.loadShow()
      if(val.id == ''){
        this.dataService.save(this.areaofstudy)
            .pipe().subscribe(data =>{
              if(data['status'] ==200){
                this.loadHide();
                this.modalReference.close();
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Area Of Study saved successfully', true);
                this.allAreaOfStudy();
              }else{
                this.alertService.error(data.message);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'})
                this.loadHide()
              } 
             
            },error =>{
              this.loadHide();
              this.alertService.error(error);
              document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
            });
      }else{
        this.dataService.areaOfStudyUpdate(this.areaofstudy)
            .pipe().subscribe(data =>{
              if(data['status'] ==200){
                this.loadHide();
                this.modalReference.close();
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Area Of Study updated successfully', true);
                this.allAreaOfStudy();
              }
              else{
                this.alertService.error(data.message);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'})
                this.loadHide()
              } 
            },error =>{
              this.loadHide();
              this.alertService.error(error);
              document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
            });
      }
    }
  }

  delete(id){
    if(confirm("Are you sure to delete")) {
      this.dataService.areaOfStudyDelete(id)
          .pipe().subscribe(data =>{
            if(data['status']==200){
              this.dtTrigger = new Subject(); //  DataTable
              this.alertService.success('Area Of Study deleted successfully', true);
              this.allAreaOfStudy();
            }else{
              this.alertService.error('Area of study error');
            }
          },error =>{
            this.alertService.error(error);
          });
    }
  }

  loadShow(){
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide(){
    this.showloding = false;
    this.lodingImage = true;
  }
 
}
